import { SortDirection } from '@gea/digital-ui-lib';
import { SORT_COLUMN } from '../state/organizations/organizations.comparator';

type ValueOf<T> = T[keyof T];

export class SimpleComparator {
  static by<T>(columnName: SORT_COLUMN, sortingOrder: SortDirection) {
    const sortUp = sortingOrder === SortDirection.ASCENDING ? 1 : -1;
    const sortDown = sortUp * -1;
    if (columnName) {
      return (a: T, b: T) => {
        const aColumnValue = a[columnName as keyof T];
        const bColumnValue = b[columnName as keyof T];
        if (a && b) {
          return getSortOrder(aColumnValue, bColumnValue, sortUp, sortDown);
        } else {
          return 0;
        }
      };
    }

    return (_a: T, _b: T) => 0;
  }
}

function getSortOrder<T>(aColumnValue: ValueOf<T>, bColumnValue: ValueOf<T>, sortUp: number, sortDown: number) {
  if (aColumnValue > bColumnValue) {
    return sortUp;
  } else if (aColumnValue < bColumnValue) {
    return sortDown;
  } else {
    return 0;
  }
}
